"use client";
import React, { useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

interface TagsInputProps {
  defaultValue?: string[];
  onTagsChange?: (tags: string[]) => void;
  className?: string;
}

export function TagsInput(props: TagsInputProps) {
  const { defaultValue = [], onTagsChange } = props;
  const [inputValue, setInputValue] = useState<string>("");
  const [tags, setTags] = useState<string[]>(defaultValue);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleInputKeyPress = (
    event: React.KeyboardEvent<HTMLInputElement>,
  ) => {
    if (event.key === "Enter" && inputValue.trim() !== "") {
      event.preventDefault();
      addTag(inputValue.trim());
      setInputValue("");
    }
  };

  const addTag = (tagName: string) => {
    const updatedTags = [...tags, tagName];
    setTags(updatedTags);
    if (onTagsChange) {
      onTagsChange(updatedTags);
    }
  };

  const removeTag = (tagIndex: number) => {
    const updatedTags = tags.filter((_, index) => index !== tagIndex);
    setTags(updatedTags);
    if (onTagsChange) {
      onTagsChange(updatedTags);
    }
  };

  return (
    <div className={`w-full mt-2 ${props.className}`}>
      <div className="flex flex-wrap justify-start items-center gap-3 rounded-md py-2 px-2 border border-zinc-950/15 data-[hover]:border-zinc-950/20 dark:border-white/10 dark:data-[hover]:border-white/20 overflow-y-hidden overflow-x-auto">
        {tags.map((tag, index) => (
          <div
            key={index}
            className="flex items-center bg-gray-100 rounded-md px-2.5 py-0.5">
            <span className="text-sm font-medium">{tag}</span>
            <span
              className="ml-2 cursor-pointer text-gray-700"
              onClick={() => removeTag(index)}>
              <XMarkIcon className="size-3 mt-0.5" />
            </span>
          </div>
        ))}
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          onKeyDown={handleInputKeyPress}
          className="w-auto h-full p-1 text-sm border-none outline-none focus:ring-0 placeholder:text-zinc-400 focus:outline-none"
          placeholder="Type and hit enter"
        />
      </div>
    </div>
  );
}
